import othersImg from '../assets/images/others.svg';
import xButton from '../assets/images/X button.png';
import qrVideo from '../assets/videos/QR.Code-Landing.Page-Normal.mp4';

function SupplementAccessCode() {
  return (
    <div className='App'>
      <div className="accessCodeScreen">
        <img src={othersImg} className="othersImgSmall" alt="Other logo" />
        <a href="./"><button className="xButton"><img src={xButton} className="xButtonImg" alt="Back" /></button></a>

        <div className="accessCodeBox">
          <p className='accessCodeText'>
            Welcome to ØTHERS!
            <br /><br />
            To support your personal journey with us, here's 2 months free access to our wellness app, featuring cultivated practices to help you relax, focus, boost energy, sleep better and much more.
            <br /><br />
            To enable your app access, please follow the instructions below:
            <br /><br />
            <span className='platformHeading'>Apple</span>
            <br />
            Click the button below and follow the instructions.
            <br /><br />
            <button
              className='submitButton storeButton'
              onClick={() => window.open('https://apps.apple.com/redeem?ctx=offercodes&id=1615837655&code=ENTEROTHERS', '_blank')}
            >
              App Store
            </button>
            <br />
            <span className='platformHeading'>Android</span>
            <br />
            Click the button below to download the ØTHERS app from the Play Store.
            <br />
            When you reach the subscription page and are given the option to input a code, type: <b>enterothers</b>
            <br /><br />
            <button
              className='submitButton storeButton'
              onClick={() => window.open('https://play.google.com/store/apps/details?id=co.others.app&hl=en-US&pli=1', '_blank')}
            >
              Play Store
            </button>
            <br />
            Finally, if you have any issues, don't hesitate to reach out to us at <a href="mailto:support@others.co">support@others.co</a>
          </p>

          <div className="accessCodeVideo">
            <video autoPlay loop muted playsInline>
              <source src={qrVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

      </div>
    </div>
  );
}

export default SupplementAccessCode;